import React, { Fragment } from "react";
import useApiFetchInfinite from "src/Hooks/Shared/useApiFetchInfinite";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useAuth from "src/Hooks/Custom/useAuth";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import GroupModal from "../GroupModal/GroupModal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type GroupProps = {
  endPoint: string;
  modalVisibility: any;
  setModalVisibility: any;
  groupData: any;
  setGroupData?: any;
  search?: string
};

function MyGroups({
  endPoint,
  setGroupData,
  modalVisibility,
  setModalVisibility,
  groupData,
  search
}: GroupProps) {
  const { t, i18n } = useTranslation();
  const { user } = AppStateHandler.getState();
  const { loading } = useAuth();
  const { data, refetch, status } = useApiFetchInfinite(
    [search ? `${endPoint}?subId=${user?.username}&search=${search}` : `${endPoint}?subId=${user?.username}`],
    {
      getFetchMore: (lastData) => {
        const nextPage = lastData?.data?.Page;
        const totalPages = lastData?.data?.TotalPages;

        return parseInt(nextPage ?? "1", 10) < totalPages
          ? `&page=${parseInt(nextPage ?? "1", 10) + 1}`
          : null;
      },
    }
  );

  if (data?.length === 0 && status === "loading") {
    return (
      <VisibilityToggle visible={loading}>
        <span className="spinner-border spinner-border-lg"></span>
        &nbsp;
      </VisibilityToggle>
    );
  }

  const arrayData = (Array.isArray(data) ? data : [])
    .map((_) => _.data.Items)
    .reduce((a, b) => a.concat(b), []);

  return (
    <>
      <VisibilityToggle visible={arrayData.length !== 0}>
        <h3 className={`fz16 mb-3 ${i18n.dir()==='rtl'?'text-right':''}`}>{t('My Groups')}</h3>
      </VisibilityToggle>
      {arrayData.map((item: any, index: number) => (
        <Link key={index} to={"/groups/" + item.id}>
          <div className="cursor-pointer">
            <div className={`d-flex justify-content-between position-relative ${i18n.dir()==='rtl'?'pr-5':'pl-5'}`}>
              <div
                className={`message_user_icon ${i18n.dir()==='rtl'?'message_user_icon_posRTL':'message_user_icon_posLTR'}`}
              >
                <img
                  src={item.group_icon}
                  className="rounded-circle object_fit"
                  width="40"
                  height="40"
                  alt=""
                />
              </div>
              <h4
                className= {`fz16 mb-1 ${i18n.dir()==='rtl'?'pr-3 text-right':'pl-3'} mb-0 poppinssemibold`}
              >
                {item.title} <br />
                <span className={`fz10 text-secondary ${i18n.dir() === "rtl" ? 'Almaraisemibold':'poppinsregular'}`}>
                  {item.total_members} {t("Members")}
                </span>
              </h4>
            </div>
            <hr />
          </div>
        </Link>
      ))}
      {modalVisibility ? (
        <GroupModal
          groupData={groupData}
          refetch={refetch}
          setGroupData={setGroupData}
          showModal={modalVisibility}
          setModalVisibility={setModalVisibility}
        />
      ) : (
          <Fragment />
        )}
    </>
  );
}

export default MyGroups;
